import { createContext, useContext } from 'react'

import { QuickPassProfileContextValue } from './quickpass-profile-context-types'

const QuickPassProfileContext =
  createContext<QuickPassProfileContextValue | null>(null)

/**
 * Reads the current profile + actions. Throws if used outside
 * QuickPassProfileProvider.
 *
 * @returns {QuickPassProfileContextValue}
 */
const useQuickPassProfile = (): QuickPassProfileContextValue => {
  const context = useContext(QuickPassProfileContext)

  if (context === null) {
    throw new Error(
      'useQuickPassProfile must be used within a QuickPassProfileProvider',
    )
  }

  return context
}

export { QuickPassProfileContext, useQuickPassProfile }
